<template>
  <div class="head-page">
    <Header :title="$t('staking.title')" />
    <div class="head-page-overflow">
      <div v-if="list.length > 0">
        <van-pull-refresh
          :pulling-text="$t('common.pulling')"
          :loosing-text="$t('common.loosing')"
          :loading-text="$t('common.loading')"
          v-model="refreshing"
          @refresh="onRefresh"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('common.nomore')"
            :loading-text="$t('common.loading')"
            :error-text="$t('common.errortxt')"
            @load="onLoad"
          >
            <StakingRecordItem @data-refresh="onRefresh" v-for="(item, index) in list" :key="index" :dataitem="item" />
            
          </van-list>
        </van-pull-refresh>
      </div>
      <div v-else>
        <van-empty :description="$t('common.nodata')" />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import StakingRecordItem from "./components/record.vue";
export default {
  name: "StakingList",
  components: { Header, StakingRecordItem },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      limit: 10,
      page: 1,
    };
  },
  mounted(){
    this.onRefresh()
  },
  methods: {
    onLoad() {
      this.getData();
    },
    async getData() {
      await this.$http({
        method: "post",
        url: "getStakingOrderList",
        data: {
          status: this.active,
          limit: this.limit,
          page: this.page,
        },
      }).then((res) => {
        this.refreshing = false;
        this.loading = false;
        if (res && res.data && res.data.list) {
          res.data.list.forEach((element) => {
            this.list.push(element);
          });
          if (res.data.list.length < this.limit) {
            this.finished = true;
          } else {
            this.page += 1;
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },
    onRefresh() {
      this.page = 1;
      this.list = [];
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    }
  }
};
</script>

<style>
</style>
